import { format as formatDateFns, isValid, parseISO } from "date-fns";

const FALLBACK_AUDIT_DATE_FORMAT = "dd-MMM-yyyy HH:mm:ss";

function toDate(value: string | Date | undefined | null): Date | null {
  if (value == null || value === "") return null;
  if (typeof value === "string" && value.trim().startsWith("0000-00-00")) {
    return null;
  }
  if (value instanceof Date) return isValid(value) ? value : null;
  const fromIso = parseISO(value);
  if (!Number.isNaN(fromIso.getTime())) return fromIso;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/**
 * Format a created/modified timestamp for audit footers.
 * Uses date-fns only; saved date_format may be non–date-fns (e.g. PHP) or unset before config loads.
 */
export function formatAuditTimestamp(
  value: string | Date | undefined | null,
  pattern: string | undefined
): string {
  const d = toDate(value);
  if (!d) return "";
  const primary = pattern?.trim() ? pattern : FALLBACK_AUDIT_DATE_FORMAT;
  try {
    return formatDateFns(d, primary);
  } catch {
    return formatDateFns(d, FALLBACK_AUDIT_DATE_FORMAT);
  }
}
